class HomeAboutZen extends HTMLElement {
  connectedCallback() {
    this.timelineItems = [...this.querySelectorAll('.section-home-about-zen__timeline-item')];
    this.descriptions = [...this.querySelectorAll('.section-home-about-zen__description')];
    this.images = [...this.querySelectorAll('[data-about-zen-image]')];
    this.yearValue = this.querySelector('[data-year-value]');
    this.timeline = this.querySelector('.section-home-about-zen__timeline');
    this.bgTrack = this.querySelector('[data-timeline-bg]');
    this.activeTrack = this.querySelector('[data-timeline-active]');
    this.dots = this.timelineItems.map(
      (item) => item.querySelector('.section-home-about-zen__timeline-dot')
    );

    this.total = this.timelineItems.length;
    if (this.total < 2) return;

    this.duration = (parseInt(this.getAttribute('data-duration'), 10) || 3) * 1000;
    this.currentIndex = 0;
    this.autoTimer = null;

    this.timelineItems.forEach((item, i) => {
      item.addEventListener('click', () => this.handleClick(i));
    });

    this.measure();
    this.activate(0);
    this.snapActiveTrack(0);

    requestAnimationFrame(() => {
      this.startAutoplay();
    });

    this._onResize = this.handleResize.bind(this);
    window.addEventListener('resize', this._onResize);
  }

  disconnectedCallback() {
    clearTimeout(this.autoTimer);
    if (this._onResize) {
      window.removeEventListener('resize', this._onResize);
    }
  }

  measure() {
    if (!this.timeline || !this.bgTrack || !this.activeTrack || this.dots.length < 2) return;

    const timelineRect = this.timeline.getBoundingClientRect();
    this.dotCenters = this.dots.map((dot) => {
      const rect = dot.getBoundingClientRect();
      return rect.left + rect.width / 2 - timelineRect.left;
    });

    const first = this.dotCenters[0];
    const last = this.dotCenters[this.dotCenters.length - 1];

    /* Background track: spans first dot → last dot */
    this.bgTrack.style.left = first + 'px';
    this.bgTrack.style.width = (last - first) + 'px';

    /* Active track: starts at first dot, width set dynamically */
    this.activeTrack.style.left = first + 'px';

    this.trackStart = first;
    this.trackWidth = last - first;
  }

  /* Distance in px from first dot to dot[index] */
  getWidth(index) {
    if (!this.dotCenters || index <= 0) return 0;
    if (index >= this.total - 1) return this.trackWidth;
    return this.dotCenters[index] - this.dotCenters[0];
  }

  /* Instantly jump active track to a dot position */
  snapActiveTrack(index) {
    if (!this.activeTrack) return;
    this.activeTrack.style.transition = 'none';
    this.activeTrack.style.width = this.getWidth(index) + 'px';
    void this.activeTrack.offsetHeight;
  }

  /* Smoothly animate active track from one dot to another */
  animateActiveTrack(fromIndex, toIndex) {
    if (!this.activeTrack) return;
    /* Snap to start position */
    this.activeTrack.style.transition = 'none';
    this.activeTrack.style.width = this.getWidth(fromIndex) + 'px';
    void this.activeTrack.offsetHeight;
    /* Animate to target */
    this.activeTrack.style.transition = 'width ' + this.duration + 'ms linear';
    this.activeTrack.style.width = this.getWidth(toIndex) + 'px';
  }

  activate(index) {
    this.currentIndex = index;

    this.timelineItems.forEach((item, i) => {
      item.classList.toggle('is-active', i === index);
      item.classList.toggle('is-passed', i < index);
    });

    this.descriptions.forEach((desc, i) => {
      desc.classList.toggle('is-active', i === index);
    });

    this.images.forEach((img, i) => {
      img.classList.toggle('is-active', i === index);
    });

    if (this.yearValue) {
      const yearEl = this.timelineItems[index]?.querySelector(
        '.section-home-about-zen__timeline-year'
      );
      if (yearEl) {
        this.yearValue.textContent = yearEl.textContent.trim();
      }
    }
  }

  startAutoplay() {
    clearTimeout(this.autoTimer);
    this.scheduleNext();
  }

  scheduleNext() {
    clearTimeout(this.autoTimer);
    const nextIndex = this.currentIndex + 1;

    if (nextIndex < this.total) {
      /* Animate the active track from current dot toward next dot */
      this.animateActiveTrack(this.currentIndex, nextIndex);

      this.autoTimer = setTimeout(() => {
        this.activate(nextIndex);
        this.scheduleNext();
      }, this.duration);
    } else {
      /* At last dot — hold, then reset to first */
      this.autoTimer = setTimeout(() => {
        this.activate(0);
        this.snapActiveTrack(0);
        requestAnimationFrame(() => {
          this.scheduleNext();
        });
      }, this.duration);
    }
  }

  handleClick(index) {
    clearTimeout(this.autoTimer);
    this.activate(index);
    this.snapActiveTrack(index);
    this.scheduleNext();
  }

  handleResize() {
    clearTimeout(this.autoTimer);
    this.measure();
    this.snapActiveTrack(this.currentIndex);
    this.startAutoplay();
  }
}

if (!customElements.get('home-about-zen')) {
  customElements.define('home-about-zen', HomeAboutZen);
}
